import { React, Header, Footer } from "../common";

const Component = ({ children }) => {
    return (
        <>
            <Header type={"Prelogin"} />
            {children}
            <Footer />
        </>
    );
};

export default Component;